// extracted by mini-css-extract-plugin
module.exports = {"content":"Quote-module--content--25D05","noBorder":"Quote-module--noBorder--a6L4Q"};